import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { BottomNavigation, BottomNavigationAction, Box, Drawer, Grid, IconButton, ListItemButton, ListItemIcon, ListItemText, Paper, Typography, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { default as Image } from '../../Assets/assetHelper';
import KenAvatar from '../../GlobalComponents/KenAvatar';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import routes from '../../Utils/routes';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import MobileSideNav from './MobileSideNav';
import NotificationDialog from './NotificationDialog';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery('(max-width:1000px)');

  const [hideSideBar, setHideSideBar] = useState(false);
  const [openNotification, setOpenNotification] = React.useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [value, setValue] = useState(0);

  const toggleDrawer = (open: boolean | ((prevState: boolean) => boolean)) => () => {
    setIsDrawerOpen(open);
  };

  const handleOpenClickOpenNotification = () => {
    setOpenNotification(true);
  };

  const handleCloseNotificationDialog = () => {
    setOpenNotification(false);
  };

  const userData = JSON.parse(`${localStorage.getItem('user')}`) as AuthUser;
  const handleListClick = (path: string, index: number) => {
    navigate(path);
  };

  const HandleAccount = () => {
    navigate(routes.profile);
  };

  useEffect(() => {
    setHideSideBar(isMobile);
  }, [isMobile]);

  const handleNavigation = (newValue: number) => {
    setValue(newValue);
    navigate(menuItems[newValue].route);
  };

  const menuItems = [
    { name: 'Home', filledIcon: <HomeIcon className={classes.icon} />, outlinedIcon: <HomeOutlinedIcon className={classes.icon} />, route: routes.home },
    // { name: 'My Documents', filledIcon: <FolderCopyIcon className={classes.icon} />, outlinedIcon: <FolderCopyIcon className={classes.icon} />, route: routes.myPortfolio },
    // { name: 'People', filledIcon: <ContactSupportOutlinedIcon className={classes.icon} />, outlinedIcon: <ContactSupportOutlinedIcon className={classes.icon} />, route: routes.people },
  ];

  return (
    <>
      {isMobile ? (
        <>
          <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
            <Box sx={{ p: '16px', pt: '50px', width: '300px', height: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'start',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #F0EDF6',
                  // pb: '32px', my: '32px'
                  height: '50px',
                }}
              >
                <Box>
                  <Typography className={classes.headerText}>{userData?.applicantName}</Typography>
                  <Typography className={classes.actionText}>{userData?.applicantEmail}</Typography>
                </Box>
              </Box>
              <Box sx={{ height: 'calc(100% - 50px)', width: '100%', minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <Box sx={{ flex: 1, width: '100%', height: '90%', overflow: 'auto' }}>
                  <MobileSideNav handleListClick={handleListClick} />
                </Box>
                <Box sx={{ mb: '0px', width: '100%', borderTop: '1px solid #F0EDF6' }}>
                  <ListItemButton
                    className={classes.menuListItemButton}
                    onClick={() => {
                      dispatch({ type: 'LOGOUT' });
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: { xs: '2px', lg: '40px' } }}>
                      <LogoutIcon className={classes.menuListItemIcon} />
                    </ListItemIcon>

                    <Typography sx={{ pl: '20px' }} className={classes.menuListItemText}>
                      Logout
                    </Typography>
                  </ListItemButton>
                </Box>
              </Box>
            </Box>
          </Drawer>
          <Box sx={{ height: '100vh', overflow: 'hidden', background: '#FFF' }}>
            <Box sx={{ borderBottom: '1px solid #F0EDF6', height: '8%' }}>
              <Box className={classes.header} style={{ boxShadow: 'none' }}>
                <Box className={classes.mobileHeaderContainer}>
                  <Box>
                    <AppBreadCrumbs />
                  </Box>
                  <IconButton aria-label="menu" onClick={toggleDrawer(true)}>
                    <KenAvatar classes={classes.avatar2} value={userData?.applicantName} />{' '}
                  </IconButton>
                </Box>
              </Box>
            </Box>
            <Box sx={{ background: '#FFF', height: '92%', overflow: 'auto' }}>
              <Box sx={{ m: '10px 16px ' }}>{children}</Box>
            </Box>
          </Box>
          {/* <Box style={{ height: '7vh' }}>
            <BottomNavigation value={value} onChange={(event, newValue) => handleNavigation(newValue)} showLabels className={classes.footerNav}>
              {menuItems.map((item, index) => (
                <BottomNavigationAction
                  key={index}
                  label={pathname.endsWith(item.route) ? item.name : ''}
                  icon={pathname.endsWith(item.route) ? item.filledIcon : item.outlinedIcon}
                  sx={{
                    height: '100%',
                    '& .MuiBottomNavigationAction-label': {
                      fontSize: '16px !important',
                      fontWeight: '500',
                      width: pathname.endsWith(item.route) ? '200px' : 'auto',
                      color: pathname.endsWith(item.route) ? '#4F4F4F' : '#8A8A8A', // Purple for selected label, gray for others
                    },
                    '& .MuiSvgIcon-root': {
                      color: pathname.endsWith(item.route) ? '#4F4F4F' : '#8A8A8A', // Purple for selected icon, gray for others
                    },
                    '&.Mui-selected': {
                      color: '#4F4F4F', // Ensures both icon and text are purple when selected
                    },
                  }}
                />
              ))}
            </BottomNavigation>
          </Box> */}
        </>
      ) : (
        <>
          <Box
            sx={{
              height: '100vh',
              width: '100vw',
              backgroundColor: '#F6F8FB',
            }}
          >
            <Grid container className={classes.mainContainer} spacing={2}>
              <Grid
                item
                xs={hideSideBar ? 1 : 2}
                sm={hideSideBar ? 0.5 : 2}
                md={hideSideBar ? 0.7 : 2}
                lg={hideSideBar ? 0.8 : 2}
                xl={hideSideBar ? 0.8 : 2}
                xxl={hideSideBar ? 0.6 : 2}
                fullHD={hideSideBar ? 0.5 : 2}
                ultraHD={hideSideBar ? 0.4 : 2}
                className={`sidebar scrollbar-cus ${hideSideBar ? 'sidebar-collapsed' : 'sidebar-expanded'}`}
              >
                <Paper className={`${classes.sideBarContainer}`}>
                  <Box className={classes.logoContainer}>
                    {!hideSideBar && (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: 'none' }}>
                        <img src={Image.Svg.ideabaazWhiteLogo} alt="logo" className={classes.logo} onClick={() => navigate('/home')} />
                      </Box>
                    )}
                  </Box>
                  <Box className={`${classes.sideBarSubContainer} scrollbar-cus`}>
                    <Box className={`${classes.sideBarSubContainer1} scrollbar-cus`}>
                      <SideNavTabs handleListClick={handleListClick} hideSideBar={hideSideBar} />
                    </Box>
                    <Box sx={{ mb: '24px' }}>
                      <ListItemButton
                        className={classes.listItemButton}
                        onClick={() => {
                          dispatch({ type: 'LOGOUT' });
                          navigate(routes.login);
                          window.location.reload();
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: { xs: '2px', lg: '40px' } }}>
                          <LogoutIcon className={classes.listItemIcon} />
                        </ListItemIcon>
                        {!hideSideBar && (
                          <ListItemText
                            className={`${classes.listItemText}  ${classes.listItemTextColor}`}
                            sx={{
                              display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                            }}
                          >
                            Logout
                          </ListItemText>
                        )}
                      </ListItemButton>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid
                item
                xs={hideSideBar ? 11 : 10}
                sm={hideSideBar ? 11.5 : 10}
                md={hideSideBar ? 11.3 : 10}
                lg={hideSideBar ? 11.2 : 10}
                xl={hideSideBar ? 11.2 : 10}
                xxl={hideSideBar ? 11.4 : 10}
                fullHD={hideSideBar ? 11.5 : 10}
                ultraHD={hideSideBar ? 11.6 : 10}
                className={`sidebar`}
              >
                <Box className={classes.headerContainer}>
                  <Box>
                    <Paper className={classes.header} sx={{ borderRadius: '16px !important' }}>
                      <Box>
                        <Typography className={classes.headerText}>
                          {pathname === routes.home ? '  Welcome to Ideabaaz, where ideas take flight and futures are built' : pathname === routes.faqs ? 'FAQs' : ''}
                        </Typography>
                        {/* <AppBreadCrumbs /> */}
                      </Box>
                    </Paper>
                  </Box>
                  <Box>
                    <Paper className={classes.actions}>
                      <Box sx={{ borderBottom: '1px solid #E8E8E8', boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)', p: '12px', borderRadius: '4px', cursor: 'pointer' }}>
                        <Typography className={classes.headerText}>{userData?.applicantName}</Typography>
                        <Typography className={classes.actionText}>{userData?.applicantEmail}</Typography>
                      </Box>
                    </Paper>
                  </Box>
                </Box>
                <Box className={`${classes.childrenContainer} scrollbar-hide`}>{children}</Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {openNotification && <NotificationDialog open={openNotification} handleClose={handleCloseNotificationDialog} />}
    </>
  );
};

export default AppLayout;
